import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable */
import { generateRandomString } from '@sainsburys-tech/boltui-utils';
var options = {
  eventName: 'quickviewLbPage',
  type: 'quickview',
  clickOrigin: 'gtlHotspotComponent',
  queryParams: {
    pageCategory: 'PDP[]',
    sectionPlacement: 'gtlHotspotComponent',
    innerPlacement: 'P1',
    sectionTitle: 'QV',
    strategy: 'alternative'
  }
};

var getTrackingParams = function getTrackingParams(trackingOptions, id) {
  var _trackingOptions$quer;

  var queryParams = trackingOptions.queryParams,
      clickOrigin = trackingOptions.clickOrigin;
  var randomString = (trackingOptions === null || trackingOptions === void 0 ? void 0 : (_trackingOptions$quer = trackingOptions.queryParams) === null || _trackingOptions$quer === void 0 ? void 0 : _trackingOptions$quer.includeRandomString) === 'true' ? ":".concat(generateRandomString(20)) : '';

  if (clickOrigin === 'hotspotRecommendations') {
    return "?clickOrigin=hotspot:".concat(queryParams.hotspotTitle, ":").concat(queryParams.hotspotProductType);
  }

  return "?rec=".concat(queryParams.pageCategory, ":").concat(queryParams.sectionPlacement, ":").concat(queryParams.innerPlacement, ":").concat(queryParams.sectionTitle, ":").concat(queryParams.strategy, ":").concat(id).concat(randomString);
};

var ensureStructure = function ensureStructure(window) {
  window.digitalData = window.digitalData || {};
  window.digitalData.page = window.digitalData.page || {};
  window.digitalData.page.lightBox = window.digitalData.page.lightBox || {};
  window.digitalData.page.lightBox.type = window.digitalData.page.lightBox.type || [];
  window.digitalData.page.lightBox.clickOrigin = window.digitalData.page.lightBox.clickOrigin || '';
  window.digitalData.page.lightBox.product = window.digitalData.page.lightBox.product || [];
  window.digitalData.event = window.digitalData.event || [];

  window.digitalData.track = window.digitalData.track || function () {};
};

var onQuickViewSlidingPanelOpen = function onQuickViewSlidingPanelOpen(_ref, trackingOptions, window) {
  var id = _ref.id,
      price = _ref.price;
  ensureStructure(window);
  window.digitalData.page.lightBox.type = trackingOptions.type;
  window.digitalData.page.lightBox.clickOrigin = trackingOptions.clickOrigin;
  window.digitalData.page.lightBox.product = [{
    id: id,
    price: price
  }];
  window.digitalData.track(trackingOptions.eventName);
};

var onQuickViewSlidingPanelShut = function onQuickViewSlidingPanelShut(window) {
  ensureStructure(window);
  window.digitalData.page = _objectSpread(_objectSpread({}, window.digitalData.page), {}, {
    lightBox: {}
  });
};

var onAddToTrolleyModalOpen = function onAddToTrolleyModalOpen(_ref2, window, trackingOptions) {
  var id = _ref2.id,
      price = _ref2.price;
  ensureStructure(window);
  window.digitalData.page.lightBox.type = 'ATT'; // eslint-disable-line

  window.digitalData.page.lightBox.product = [{
    id: id,
    price: price
  }]; // eslint-disable-line

  var event = {
    eventInfo: {
      eventName: 'addToTrolley',
      eventAction: 'Add to Trolley'
    },
    attributes: {
      clickOrigin: trackingOptions.clickOrigin === 'hotspotRecommendations' ? 'hotspotLb:ATT' : 'quickviewLb:ATT',
      product: [{
        id: id,
        price: price
      }]
    }
  };
  window.digitalData.event.push(event);
  window.digitalData.track(event.eventInfo.eventName);
};

export { ensureStructure, onQuickViewSlidingPanelOpen, onQuickViewSlidingPanelShut, onAddToTrolleyModalOpen, getTrackingParams, options };